module.exports = __webpack_public_path__ + "static/logo-cea82b3899afbbaba043fc53f34681e0.jpg";